import { SwChatClient } from '@swchat/client-sdk';
import { backend, initCrypto } from '@swchat/crypto-wasm';
import wasmUrl from '@swchat/crypto-wasm/wasm?url';
import { IdbStore } from './idb-store';
import { buildPortalProjectUrl } from './portal-url';

export const PORTAL_URL = import.meta.env.VITE_PORTAL_URL ?? 'http://localhost:4000';
/** `oidc` = đăng nhập qua IdP OpenID Connect (sid): /authorize + scope; mặc định giao thức 7w_portal (/sso/authorize). */
export const PORTAL_PROTOCOL = import.meta.env.VITE_PORTAL_PROTOCOL === 'oidc' ? 'oidc' : 'portal';
export const PORTAL_CLIENT_ID = import.meta.env.VITE_PORTAL_CLIENT_ID || 'swchat';

/** W2.5: mẫu URL trang dự án trên 7wportal (`{id}` = id dự án phía portal); mặc định `${PORTAL_URL}/projects/{id}`. */
const PORTAL_PROJECT_URL = import.meta.env.VITE_PORTAL_PROJECT_URL || `${PORTAL_URL.replace(/\/+$/, '')}/projects/{id}`;

/** W2.5: URL "Mở trên 7wportal" của dự án (logic ở `portal-url.ts` để unit test được). */
export const portalProjectUrl = (projectId: string, template = PORTAL_PROJECT_URL) => buildPortalProjectUrl(projectId, template);

function deviceName() {
  const ua = navigator.userAgent;
  const browser = /Electron\//.test(ua) ? 'App desktop' : /Edg\//.test(ua) ? 'Edge' : /Chrome\//.test(ua) ? 'Chrome' : /Firefox\//.test(ua) ? 'Firefox' : /Safari\//.test(ua) ? 'Safari' : 'Trình duyệt';
  const os = /Windows/.test(ua) ? 'Windows' : /Mac OS/.test(ua) ? 'macOS' : /Android/.test(ua) ? 'Android' : /iPhone|iPad/.test(ua) ? 'iOS' : /Linux/.test(ua) ? 'Linux' : '';
  return `${browser}${os ? ` · ${os}` : ''}`;
}

let clientPromise: Promise<SwChatClient> | undefined;

/** Một client cho cả tab: khởi tạo WASM, mở IndexedDB, khôi phục phiên đã lưu. */
export function getClient(): Promise<SwChatClient> {
  clientPromise ??= (async () => {
    await initCrypto(wasmUrl);
    const client = new SwChatClient({
      baseUrl: window.location.origin,
      crypto: backend,
      store: await IdbStore.open(),
      device: { name: deviceName(), platform: 'web' },
    });
    await client.init();
    return client;
  })();
  return clientPromise;
}
